// frontend/src/components/chat/experience/externalUrl.ts
/**
 * Best URL for opening a source outside the app, or null to hide the
 * action. proxy-type URLs are relative paths that need an x-api-key
 * header — only the already-fetched blob: URL (pdf/image embeds) makes
 * them openable; 'reference' URLs are opaque provenance strings.
 */
import type { DisplaySource } from '@/types/source'
import { isPdfSource } from './isPdfSource'

export interface ExternalUrlContext {
  embedUrl?: string | null
  scormEntryUrl?: string | null
}

const SELF_AUTHENTICATING: ReadonlyArray<DisplaySource['storage_url_type']> = [
  'sas',
  'direct',
  'presigned',
]

export function getExternalUrl(
  source: DisplaySource,
  ctx: ExternalUrlContext = {}
): string | null {
  if (source.mediaType === 'web') return source.original_url ?? null
  if (source.mediaType === 'scorm') return ctx.scormEntryUrl ?? null
  if (source.isExpired) return null
  if (source.mediaType === 'image' || isPdfSource(source)) return ctx.embedUrl ?? null
  if (SELF_AUTHENTICATING.includes(source.storage_url_type)) return source.storage_url ?? null
  return null
}
